import apiClient from "./client";

export async function fetchBattles(params = {}, signal) {
  const response = await apiClient.get("battles/", { params, signal });
  return response.data;
}

export async function fetchHomeBattles(signal) {
  const response = await apiClient.get("battles/home/", { signal });
  return response.data;
}

export async function fetchUpcomingBattles(signal) {
  const response = await apiClient.get("battles/upcoming/", { signal });
  return response.data;
}

export async function fetchBattleDetail(battleId, signal) {
  const response = await apiClient.get(`battles/${battleId}/`, { signal });
  return response.data;
}

export async function createBattle(payload) {
  const response = await apiClient.post("battles/", payload);
  return response.data;
}

export async function updateBattleParticipation(battleId, action) {
  const response = await apiClient.post(`battles/${battleId}/participation/`, {
    action,
  });
  return response.data;
}

export async function cancelBattle(battleId) {
  const response = await apiClient.post(`battles/${battleId}/cancel/`);
  return response.data;
}

export async function fetchActiveBattleForCategory(categorySlug, signal) {
  const response = await apiClient.get("battles/", {
    params: { category: categorySlug, status: "open" },
    signal,
  });
  const battles = response.data?.battles || [];
  return battles[0] || null;
}
